module.exports = __webpack_public_path__ + "static/media/Daily Emails for Potential Client.bfa9df61.png";